module.exports = __webpack_public_path__ + "img/kuyucuk-bg-1-2@2x.bb33ac84.png";